import "./footer.css";
import axios from "axios";
import {useEffect, useState} from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import Person3OutlinedIcon from "@mui/icons-material/Person3Outlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CachedIcon from "@mui/icons-material/Cached";
import {Link} from "react-router-dom";
import LiveChat from "react-livechat";

function Footer(props) {
	var profile = props.profile;
	const data = [
		{
			icon: <HomeOutlinedIcon />,
			title: "Trang chủ",
			to: "/",
		},
		{
			icon: (
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" width="24" height="24" strokeWidth="0.7">
					<path d="M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z" />
				</svg>
			),
			title: "Tiktok",
			to: "/",
		},
		{
			icon: <TrendingUpIcon />,
			title: "Xu hướng",
			to: "/trend",
		},
		{
			icon: <Person3OutlinedIcon />,
			title: "Trang cá nhân",
			to: "/mine",
		},
		{
			icon: <HeadsetMicOutlinedIcon />,
			title: "CSKH",
			to: "/cskh",
		},
	];

	return (
		<>
			<div className="bg-menu">
				<div className="detail_id">
					{profile != null ? (
						<>
							<div className="item_id">Mã TTLK : {Number(profile.iduser) + 2000}</div>
							<div>
								Hoa hồng: <b>{props.profile.money.toLocaleString()}</b>
							</div>
						</>
					) : null}
				</div>
				<div className="footer">
					{data.map((item, index) => (
						<>
							{index == 1 ? (
								<div className="item-footer" key={index}>
									<div onClick={() => (window.location.href = "https://tiktok.com")}>
										<div className="icon_footer">{item.icon}</div>
										<div className="title_footer">{item.title}</div>
									</div>
								</div>
							) : (
								<div className="item-footer" key={index}>
									<Link style={{textDecoration: "none"}} to={item.to}>
										<div className="icon_footer">{item.icon}</div>
										<div className="title_footer">{item.title}</div>
									</Link>
								</div>
							)}
						</>
					))}
				</div>
			</div>
		</>
	);
}
export default Footer;
